import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/2.jpg');

const filters = [
    { label: "البناء", filter: ".cat-1" },
    { label: "التجديد", filter: ".cat-2" },
    { label: "الخارجي", filter: ".cat-3" },
    { label: "الداخلي", filter: ".cat-4" },
    { label: "الاستشارة", filter: ".cat-5" },
];

const ProjectGrid = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Helper function to convert blob to image URL
    const convertBlobToImageUrl = (blob) => {
        if (!blob) return '/images/placeholder.jpg';
        
        try {
            // If blob is base64 string, use it directly
            if (typeof blob === 'string') {
                if (blob.startsWith('data:image/')) {
                    return blob;
                }
                // If it's base64 without data URL prefix, add it
                return `data:image/jpeg;base64,${blob}`;
            }
            
            // If blob is array buffer or uint8array, convert to base64
            if (blob instanceof ArrayBuffer || blob instanceof Uint8Array) {
                const bytes = new Uint8Array(blob);
                let binary = '';
                for (let i = 0; i < bytes.byteLength; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                const base64 = btoa(binary);
                return `data:image/jpeg;base64,${base64}`;
            }
            
            return '/images/placeholder.jpg';
        } catch (error) {
            console.error('Error converting blob to image URL:', error);
            return '/images/placeholder.jpg';
        }
    };

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                setLoading(true);
                const response = await axios.get('https://alaussback-production.up.railway.app/api/projects');
                
                // Process projects to handle blob images
                const processedProjects = response.data.map(project => ({
                    ...project,
                    imageUrl: convertBlobToImageUrl(project.image || project.thumb || project.imageData)
                }));
                
                setProjects(processedProjects);
                setError(null);
            } catch (err) {
                console.error('Error fetching projects:', err);
                setError('فشل في تحميل المشاريع');
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    useEffect(() => {
        // Load masonry script after projects are loaded
        if (projects.length > 0) {
            const loadScript = (src) => {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = src;
                    script.addEventListener('load', () => resolve());
                    script.addEventListener('error', (e) => reject(e));
                    document.body.appendChild(script);
                    document.body.removeChild(script);
                });
            };

            loadScript('./assets/js/masonary.js').catch(console.error);
        }
    }, [projects]);

    if (loading) {
        return (
            <div dir="rtl">
                <Header />
                <div className="page-content">
                    <Banner title="دائما مخلصين و متفانين" pagename="المشاريع" bgimage={bnrimg} />
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="text-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                <h3>جاري التحميل...</h3>
                                <div className="loading-spinner">
                                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div dir="rtl">
                <Header />
                <div className="page-content">
                    <Banner title="دائما مخلصين و متفانين" pagename="المشاريع" bgimage={bnrimg} />
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="text-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                <h3 style={{ color: '#dc3545' }}>{error}</h3>
                                <button 
                                    className="site-button btn-effect mt-3"
                                    onClick={() => window.location.reload()}
                                >
                                    إعادة المحاولة
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div dir="rtl">
            <Header />
            <div className="page-content">
                <Banner title="دائما مخلصين و متفانين" pagename="المشاريع" bgimage={bnrimg} />

                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        {/* Filter buttons - optional, can be implemented based on your needs */}
                     

                        <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                            {projects.map((item, index) => (
                                <div key={item.id || index} className={`masonry-item col-md-4 col-sm-6 m-b30`}>
                                    <div className="image-effect-two hover-shadow" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                        <img 
                                            src={item.imageUrl || '/images/placeholder.jpg'} 
                                            alt={item.title || 'مشروع'} 
                                            style={{ width: '100%', height: '450px', objectFit: 'cover' }}
                                            onError={(e) => {
                                                e.target.src = '/images/placeholder.jpg';
                                            }}
                                        />
                                        <div className="figcaption" style={{ textAlign: 'right' }}>
                                            <h4 className="mt-tilte" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                                {item.title || item.name || 'مشروع'}
                                            </h4>
                                            <p style={{ 
                                                fontFamily: 'Cairo, sans-serif', 
                                                textAlign: 'right',
                                                lineHeight: '1.6'
                                            }}>
                                                {item.description || item.details || 'لا يوجد وصف متاح'}
                                            </p>
                                            <NavLink 
                                                to={`/project-detail/${item.id}`} 
                                                className="read-more site-button btn-effect"
                                                style={{ fontFamily: 'Cairo, sans-serif' }}
                                            >
                                                إقرأ أكثر
                                            </NavLink>
                                            <a 
                                                className="mfp-link" 
                                                href={item.imageUrl || '/images/placeholder.jpg'}
                                            >
                                                <i className="fa fa-arrows-alt" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {projects.length === 0 && !loading && (
                            <div className="text-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                <h3>لا توجد مشاريع متاحة حاليًا</h3>
                                <p>يرجى المحاولة مرة أخرى لاحقًا</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ProjectGrid;